import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


//************* TITULACION  ***************************/
import { EstudianteRequerimientosService } from '../../../../shared/services/titulacion/estudianteRequerimientos/estudianteRequerimientos.service';
import { EtapaTitulacionService } from '../../../../shared/services/titulacion/etapaTitulacion/etapaTitulacion.service';
import { HistorialSolicitudService } from '../../../../shared/services/titulacion/historialSolicitud/historialSolicitud.service';
import { ModalidadesService } from '../../../../shared/services/titulacion/modalidades/modalidades.service';
import { ModalidadesSolicitudService } from '../../../../shared/services/titulacion/modalidadesSolicitud/modalidadesSolicitud.service';
import { NotaDefensaService } from '../../../../shared/services/titulacion/notaDefensa/notaDefensa.service';
import { ObservacionPersonaService } from '../../../../shared/services/titulacion/observacionPersona/observacionPersona.service';
import { ObservacionTutorExService } from '../../../../shared/services/titulacion/observacionTutorEx/observacionTutorEx.service';
import { RequerimientoService } from '../../../../shared/services/titulacion/requerimiento/requerimiento.service';
import { RequisitosAcademicosService } from '../../../../shared/services/titulacion/requisitosAcademicos/requisitosAcademicos.service';
import { SolicitudActividadService } from '../../../../shared/services/titulacion/solicitudActividad/solicitudActividad.service';
import { SolicitudDefensaService } from '../../../../shared/services/titulacion/solicitudDefensa/solicitudDefensa.service';
import { SolicitudEntregaService } from '../../../../shared/services/titulacion/solicitudEntrega/solicitudEntrega.service';
import { SolicitudEstudianteService } from '../../../../shared/services/titulacion/solicitudEstudiante/solicitudEstudiante.service';
import { SolicitudPersonaTitulacionService } from '../../../../shared/services/titulacion/solicitudPersonaTitulacion/solicitudPersonaTitulacion.service';
import { SolicitudRequerimientoService } from '../../../../shared/services/titulacion/solicitudRequerimiento/solicitudRequerimiento.service';
import { SolicitudTutorExService } from '../../../../shared/services/titulacion/solicitudTutorEx/solicitudTutorEx.service';
import { TipoPersonaService } from '../../../../shared/services/titulacion/tipoPersona/tipoPersona.service';
import { TipoTitulacionService } from '../../../../shared/services/titulacion/tipoTitulacion/tipoTitulacion.service';
import { TutorExService } from '../../../../shared/services/titulacion/tutorEx/tutorEx.service';
import { SolicitudRequisitoService } from '../../../../shared/services/titulacion/solicitudRequisito/solicitudRequisito.service';
import { NotasDefensaExService } from '../../../../shared/services/titulacion/notasDefensaEx/notasDefensaEx.service';
import { ActaGradoService } from '../../../../shared/services/titulacion/actaGrado/actaGrado.service';
import { TipoTitulacionCatalogoService } from '../../../../shared/services/titulacion/tipoTitulacionCatalogo/tipoTitulacionCatalogo.service';
import { TituloService } from '../../../../shared/services/titulacion/titulo/titulo.service';
import { SolicitudService } from '../solicitud/solicitud.service';
import { BloqueoTramiteTitulacionService } from '../bloqueoTramiteTitulacion/bloqueoTramiteTitulacion.service';
import { Interceptor } from '../../token/interceptor';
import { SolicitudTitulacionService } from '../solicitudTitulacion/solicitudTitulacion.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedTitulacionModule {
  static forRoot(): ModuleWithProviders<SharedTitulacionModule> {
    return {
      ngModule: SharedTitulacionModule,
      providers: [
        EtapaTitulacionService, RequerimientoService, SolicitudActividadService,
        SolicitudRequerimientoService, TipoTitulacionService, ModalidadesService,
        ModalidadesSolicitudService, SolicitudTutorExService, TutorExService,
        SolicitudTutorExService, TutorExService, HistorialSolicitudService,
        EstudianteRequerimientosService, HistorialSolicitudService, ModalidadesService,
        ModalidadesSolicitudService, NotaDefensaService, ObservacionPersonaService,
        ObservacionTutorExService, RequerimientoService, RequisitosAcademicosService,
        SolicitudActividadService, SolicitudDefensaService, SolicitudEntregaService,
        SolicitudEstudianteService, SolicitudRequerimientoService, SolicitudTutorExService,
        TipoPersonaService, TipoTitulacionService, TutorExService, SolicitudPersonaTitulacionService,
        SolicitudRequisitoService, NotasDefensaExService,
        ActaGradoService, TipoTitulacionCatalogoService,
        TituloService, SolicitudService, BloqueoTramiteTitulacionService, SolicitudTitulacionService,

        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}